/**
 * EmptyState — shown when a list or section has nothing to display.
 *
 * Props:
 *   title        string  main line, e.g. "לא נמצאו לקוחות"
 *   description  node    optional hint below
 *   action       node    optional button (e.g. "נקה מסננים")
 *   compact      bool    smaller version for sections inside cards/drawers
 *
 * Usage:
 *   <EmptyState title="לא נמצאו לקוחות" description="נסו לשנות את המסננים" action={<Button>נקה</Button>} />
 */
import React from 'react';
import { Empty } from 'antd';
import styles from './EmptyState.css';

const EmptyState = ({ title, description, action, compact }) => (
  <div className={compact ? styles.compact : styles.wrap}>
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <div>
          <div className={styles.title}>{title}</div>
          {description ? <div className={styles.description}>{description}</div> : null}
        </div>
      }
    >
      {action || null}
    </Empty>
  </div>
);

export default EmptyState;
